import { styled } from '@mui/joy';

export const MenuContainer = styled('div')({
  width: '196px',
  backgroundColor: '#F5F5F5',
  borderRight: '1px solid #E0E0E0',
  height: '100%',
  display: 'flex',
  flexDirection: 'column',
  fontSize: '14px',
  flexShrink: 0,
});

export const MenuSection = styled('div')({
  borderBottom: '1px solid #E0E0E0',
  padding: '4px 0',
});

export const MenuHeader = styled('div')({
  padding: '4px 10px',
  fontWeight: 600,
  color: '#333333',
  fontSize: '14px',
  textTransform: 'uppercase',
  letterSpacing: '0.5px',
});

export const MenuItem = styled('button')<{ active?: boolean; indent?: boolean }>(
  ({ active, indent }) => ({
    width: '100%',
    padding: '2px 8px',
    paddingLeft: indent ? '20px' : '8px',
    border: 'none',
    backgroundColor: active ? '#E3F2FD' : 'transparent',
    color: active ? '#1976D2' : '#333333',
    fontSize: '14px',
    textAlign: 'left',
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    gap: '3px',
    transition: 'background-color 0.2s',

    '&:hover': {
      backgroundColor: active ? '#E3F2FD' : '#E8E8E8',
    },
  })
);

export const MenuDivider = styled('div')({
  height: '1px',
  backgroundColor: '#E0E0E0',
  margin: '2px 0',
});

export const ExpandIcon = styled('div')<{ expanded?: boolean }>(({ expanded }) => ({
  width: '12px',
  height: '12px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  transition: 'transform 0.2s',
  transform: expanded ? 'rotate(90deg)' : 'rotate(0deg)',
}));
